import api from '../services/api';

// ============================================================
// POOJA TYPES — ab API se aate hain, hardcoded nahi
//
// Pehle yahan ek plain array tha. Dikkat ye thi ki poojari apni
// pooja add nahi karwa sakta tha — jo list mein nahi hai wo wo
// offer hi nahi kar sakta tha.
//
// Ab list DB se aati hai:
//   GET /api/poojaris/pooja-types   (public, bina login ke)
//
// Poojari nayi pooja ka proposal bhej sakta hai, admin approve
// karta hai, phir wo sabke dropdown mein aa jaati hai.
// ============================================================

/**
 * Purane 26 naam — SIRF FALLBACK ke liye.
 *
 * ⚠️ Ise seedha use MAT karna. fetchPoojaTypes() use karo.
 *
 * Ye tab kaam aata hai jab API fail ho jaaye. Bina iske register
 * page pe dropdown KHAALI ho jaata aur poojari register hi nahi kar
 * paata — matlab ek network hichki se onboarding ruk jaati.
 *
 * ⚠️ Ye list DB ke seed (V9) se hi aayi hai. Dono ka mel rehna
 *    chahiye, par ye purani ho jaaye to bhi bada nuksaan nahi —
 *    ye sirf tab dikhti hai jab API pahunch se bahar ho.
 */
export const FALLBACK_POOJA_TYPES = [
    'Satyanarayan Pooja',
    'Ganesh Pooja',
    'Griha Pravesh',
    'Vastu Pooja',
    'Wedding Ceremony',
    'Namakaran',
    'Mundan Ceremony',
    'Annaprashan',
    'Navratri Pooja',
    'Durga Pooja',
    'Lakshmi Pooja',
    'Saraswati Pooja',
    'Shiva Abhishek',
    'Rudrabhishek',
    'Hanuman Pooja',
    'Navgraha Shanti',
    'Kaal Sarp Dosh Nivaran',
    'Mahamrityunjaya Jaap',
    'Katha Paath',
    'Sunderkand Path',
    'Bhagwat Katha',
    'Havan / Yagya',
    'Shraddh Karma',
    'Vehicle Pooja',
    'Shop Opening Pooja',
    'Bhoomi Pooja'
];

// ============================================================
// CACHE
//
// Teen page ek hi list maangte hain — Home, PoojariRegister,
// PoojariProfile2. Har baar API hit karna bekaar hai.
//
// ⚠️ Do variable hain, ek nahi:
//    cache        — laayi hui list
//    inFlight     — abhi chal rahi call ka promise
//
//    inFlight ke bina do component ek saath mount hon to DO call
//    jaati. Ab dono ek hi promise ka intezaar karte hain.
// ============================================================
let cache = null;
let inFlight = null;

/**
 * Pooja types ki list laao — STRINGS ka array.
 *
 * ⚠️ Objects nahi, sirf naam. Poora frontend string pe match karta
 *    hai (filter, accordion, pre-select), aur backend mein bhi
 *    poojari ki service mein naam STRING ki tarah save hota hai.
 *    Objects dete to teen file mein har jagah .name lagana padta.
 *
 * @param {boolean} force true bhejo to cache chhod ke taazi list
 *                  laayega. Proposal approve hone ke baad kaam aata
 *                  hai.
 */
export const fetchPoojaTypes = async (force = false) => {
    if (!force && cache) {
        return cache;
    }

    // Koi aur pehle se laa raha hai — usi ka intezaar karo
    if (!force && inFlight) {
        return inFlight;
    }

    inFlight = api.get('/api/poojaris/pooja-types')
        .then(res => {
            const names = (res.data || [])
                .map(t => t.name)
                .filter(Boolean);

            // ⚠️ Khaali jawab aaya to fallback. Aisa tab hoga jab
            //    DB seed hi na hui ho. Khaali dropdown dikhane se
            //    behtar hai purani list dikhana.
            cache = names.length > 0 ? names : FALLBACK_POOJA_TYPES;
            return cache;
        })
        .catch(err => {
            console.error('Pooja types load nahi hui:', err);
            // ⚠️ cache SET NAHI kar rahe — agli baar dobara try
            //    karega. Fallback ko cache kar diya to network
            //    wapas aane pe bhi purani list hi chalti rehti.
            return FALLBACK_POOJA_TYPES;
        })
        .finally(() => {
            inFlight = null;
        });

    return inFlight;
};

/**
 * Cache saaf karo.
 *
 * Tab use karo jab list badalne ka pata ho — jaise poojari ka
 * proposal approve hua ho.
 */
export const clearPoojaTypesCache = () => {
    cache = null;
    inFlight = null;
};

// ============================================================
// BAAKI SAB — pehle jaisa hi, kuch nahi badla
// ⚠️ CreateBooking.js formatDuration import karta hai
// ============================================================

// Languages
export const LANGUAGES = [
    'Hindi',
    'Sanskrit',
    'English',
    'Odia',
    'Bengali',
    'Marathi',
    'Gujarati',
    'Tamil',
    'Telugu',
    'Kannada',
    'Malayalam',
    'Punjabi',
    'Assamese',
    'Bhojpuri',
    'Urdu'
];

// ⚠️ Duration ke saare option - ghante AUR din.
//
//    Asli poojaein chhoti nahi hoti: Navratri 9 din, Bhagwat Katha
//    5-10 din, Akhand Ramayan 1-2 din.
//
// ⚠️ PURANA TAREEKA: din bhi minutes mein rakhe jaate the
//    (2880 = 2 din). Wo galat tha - slot check waqt se waqt tak
//    ginta, jabki multi-day pooja mein AAKHRI DIN KI RAAT tak block
//    hona chahiye. Aakhri din aksar sabse bada hota hai
//    (purnahuti, bhandara).
//
//    Ab days alag field hai. days > 1 = poora din block.
export const DURATION_OPTIONS = [
    { minutes: 30, days: 1, label: '30 min' },
    { minutes: 45, days: 1, label: '45 min' },
    { minutes: 60, days: 1, label: '1 hour' },
    { minutes: 90, days: 1, label: '1.5 hours' },
    { minutes: 120, days: 1, label: '2 hours' },
    { minutes: 180, days: 1, label: '3 hours' },
    { minutes: 240, days: 1, label: '4 hours' },
    { minutes: 300, days: 1, label: '5 hours' },
    { minutes: 360, days: 1, label: '6 hours' },
    { minutes: 420, days: 1, label: '7 hours' },
    { minutes: 480, days: 1, label: '8 hours' },
    { minutes: 1440, days: 1, label: 'Full day' },
    { minutes: 1440, days: 2, label: '2 days' },
    { minutes: 1440, days: 3, label: '3 days' },
    { minutes: 1440, days: 4, label: '4 days' },
    { minutes: 1440, days: 5, label: '5 days' },
    { minutes: 1440, days: 6, label: '6 days' },
    { minutes: 1440, days: 7, label: '7 days' },
    { minutes: 1440, days: 8, label: '8 days' },
    { minutes: 1440, days: 9, label: '9 days' },
    { minutes: 1440, days: 10, label: '10 days' },
    { minutes: 1440, days: 11, label: '11 days' },
    { minutes: 1440, days: 12, label: '12 days' },
    { minutes: 1440, days: 13, label: '13 days' },
    { minutes: 1440, days: 14, label: '14 days' },
    { minutes: 1440, days: 15, label: '15 days' }
];

/**
 * Dropdown ke liye ek hi value - "minutes_days".
 *
 * ⚠️ HTML select ek hi value rakh sakta hai, par hamein do chahiye.
 *    Jod ke ek string banate hain, chunne par tod dete hain.
 */
export const durationValue = (minutes, days) => `${minutes}_${days || 1}`;

/**
 * Duration ko padhne layak text mein badlo.
 *
 * ⚠️ days > 1 ho to WAHI dikhana hai - minutes ka tab koi matlab
 *    nahi, poora din block hota hai.
 */
export const formatDuration = (minutes, days) => {

    // ⚠️ days pehle dekhna hai. Multi-day mein minutes 1440 hota
    //    hai, aur bina is check ke "1 day" dikhta - jabki 9 din ki
    //    pooja hai.
    if (days && days > 1) {
        return `${days} days`;
    }

    if (!minutes) return '';
    if (minutes < 60) return `${minutes} min`;

    if (minutes < 1440) {
        const hrs = minutes / 60;
        return hrs === 1
            ? '1 hour'
            : `${hrs % 1 === 0 ? hrs : hrs.toFixed(1)} hours`;
    }

    return 'Full day';
};